// This file is automatically generated. Do not edit it directly.
// FieldIDX Supabase Client
// Schema version: 1.1.0
// Account types: 'hs_athlete' | 'athlete' (college) | 'enterprise'
// RLS enforced at DB level — do not bypass with service role on frontend
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://vvekneamglpebxdcryoz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ2ZWtuZWFtZ2xwZWJ4ZGNyeW96Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwMjkyODYsImV4cCI6MjA4MTYwNTI4Nn0.x4uIXfgS1obWVS0vMdp8c28C1TAAgG_i-YpWD-UahLg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    lock: async (_name, _acquireTimeout, fn) => fn(), // bypass navigatorLock
  }
});